import { create } from 'zustand';
import type { UserState } from './types';

/**
 * User store - anonymous in Phase 1.
 *
 * Per ADR-PROTO-006, `userId` is the persistence key; localStorage entries
 * for pathways, overrides, and citations are namespaced as
 * `cps:${userId}:${key}`. In Phase 2, `userId` becomes the auth subject
 * claim from the IdP; the store interface does not change.
 */
export const useUserStore = create<UserState>((set) => ({
  userId: 'anonymous',
  setUserId: (userId) => set({ userId }),
}));
